import type { ISerialize } from '@/objects/ISerialize';

export class RaceContestantWithPointsRequest implements ISerialize {
    public Bib: number;

    public RaceID: number | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Bib?: number; RaceID?: number | null }) {
        this.Bib = values.Bib ?? 0;

        this.RaceID = values.RaceID ?? null;
    }

    public serialize(): string {
        return '{' + `"Bib": ${JSON.stringify(this.Bib)}` + ',' + `"RaceID": ${JSON.stringify(this.RaceID)}` + '}';
    }

    /**
     * Creates an instance of RaceContestantWithPointsRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Bib?: number; RaceID?: number | null }): RaceContestantWithPointsRequest {
        return new RaceContestantWithPointsRequest(values);
    }

    public static _FromServerJson(json: any): RaceContestantWithPointsRequest {
        return new RaceContestantWithPointsRequest({ Bib: json.Bib, RaceID: json.RaceID ?? null });
    }

    /**
     * Creates an instance of RaceContestantWithPointsRequest from another instance of RaceContestantWithPointsRequest.
     * @param other The RaceContestantWithPointsRequest you want to clone
     * @returns A cloned RaceContestantWithPointsRequest
     */
    public static FromOther(other: RaceContestantWithPointsRequest): RaceContestantWithPointsRequest {
        return RaceContestantWithPointsRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return RaceContestantWithPointsRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'RaceContestantWithPointsRequest';
}
